// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"f3ce988f","401":"86ef35b7","435":"c060c190","455":"155d65ec","529":"c060c190","540":"63234c2a","912":"c060c190"}[chunkId] + ".chunk.css";
};